/* eslint-env browser */

import * as React from 'react'

require('../../container/client')

const ReactDOM = require('react-dom')
const DomHelper = require('../../client/clientjs/dom-helper')
const SearchSpecies = require('../../client/clientjs/components/search/SearchSpecies')

DomHelper.onDocumentReady(() => {
  const renderSearchSpeciesElt = DomHelper.query('#react-render-species')
  if (renderSearchSpeciesElt) {
    ReactDOM.hydrate(
      <SearchSpecies
        locale={window.initialState.locale.identifierShort}
        species={window.initialState.species}
        perPage={window.initialState.search.perPage}
        page={window.initialState.search.page}
        query={window.initialState.search.query}
        totalCount={window.initialState.search.totalCount}
        host={window.initialState.config.host}
      />,
      renderSearchSpeciesElt
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
